function main() {
  const hamburgerBtn = document.querySelector(".hamburger");
  const mobileMenuLinks = document.querySelector(".mobile-menu-links");
  const projectsBtn = document.querySelector(".projects-btn");
  const projectsDropdown = document.querySelector(".projects-dropdown");

  hamburgerBtn.addEventListener("click", () => {
    hamburgerBtn.classList.toggle("is-active");
    mobileMenuLinks.classList.toggle("is-active");
  });

  projectsBtn.addEventListener("click", () =>{
      projectsDropdown.classList.toggle("is-active");
  })
}

export default main;
